import styles from "./titleStyles.js";
import { Container, Typography } from "@mui/material";

const Title = ({ title = "Titulo" }) => {
  return (
    <Container style={styles.mainContainer}>
      <Typography sx={styles.title}>{title}</Typography>
    </Container>
  );
};

export default Title;
